import { ConditionCreators } from '@leverege/ui-condition';
import { LogicCondition } from '@leverege/condition';
import { AttributeCondition } from '@leverege/ui-attributes';
import { GroupDelegate } from '@leverege/molten-core';
const conditionOptions = {};
const conditions = [LogicCondition, AttributeCondition];
const processBlueprints = (molten, blueprints) => {
  const creators = ConditionCreators.toCreators(conditions);
  blueprints.forEach(blueprint => {
    molten.addPlugin('ConditionFilterOptionsCreator', {
      delegateType: GroupDelegate.TYPE,
      objectType: blueprint.type,
      create: props => {
        const {
          delegate
        } = props;
        const key = `${GroupDelegate.TYPE}:${blueprint.type}`;
        if (!conditionOptions[key]) {
          conditionOptions[key] = {
            logicalOperators: ['and', 'or'],
            attributeCondition: {
              attributeFilter: attr => {
                // TODO: MOLTEN-594 Rename 'blueprint' attribute on the imagine attributes to source, and given them a type
                return attr?.getOption?.('filterable') === true;
              },
              comparatorFilter: plg => {
                return delegate.canConvertComparator(plg, {
                  ...props,
                  objectType: blueprint.type
                });
              }
            }
          };
        }
        return {
          creators,
          conditionOptions: conditionOptions[key]
        };
      }
    });
  });
};
export default {
  id: 'molten.imagine.ConditionFilterOptionsBlueprintsProcessor',
  processBlueprints
};